// soundField.js
import Utils from '../utils';
import { SOUND } from '../constants';

export function createSoundField(config = {}) {
  const opts = {
    baseId: '0막',
    baseMin: SOUND.BASE_MIN,
    baseMax: SOUND.BASE_MAX,
    baseRadius: SOUND.BASE_RADIUS,
    layerRadius: SOUND.LAYER_RADIUS,
    ...config,
  };

  const { baseId, baseMin, baseMax, baseRadius, layerRadius } = opts;

  function curve(t) {
    return t * t * t;
  }

  function proximityFromDistance(dist, radius) {
    const t = Utils.clamp(1 - dist / radius, 0, 1);
    return curve(t);
  }

  function computeTargets({
    mouseWorld,
    stageById,
    onTarget = () => {},
    onProximity = () => {},
  }) {
    // 0막
    const baseStage = stageById.get(baseId);
    if (baseStage) {
      const c0 = Utils.getItemCenter(baseStage);
      const d0 = Utils.dist(mouseWorld.x, mouseWorld.y, c0.x, c0.y);

      const p0 = proximityFromDistance(d0, baseRadius);
      const baseVol = Utils.lerp(baseMin, baseMax, p0);

      onTarget(baseId, baseVol);
      onProximity(baseId, p0);
    }

    for (const [id, stage] of stageById) {
      if (id === baseId) continue;

      const c = Utils.getItemCenter(stage);
      const d = Utils.dist(mouseWorld.x, mouseWorld.y, c.x, c.y);

      const p = proximityFromDistance(d, layerRadius);
      onTarget(id, p);
      onProximity(id, p);
    }
  }
  return { computeTargets };
}
